import { useTranslations } from 'next-intl'
import dynamic from 'next/dynamic'
import Image from 'next/image'
import { useState } from 'react'

const ModalDescriptionReferFriend = dynamic(
  () =>
    import('@/components/common/refer-friend/modal-description-refer').then(
      (mod) => mod.ModalDescriptionReferFriend
    ),
  {
    ssr: false,
  }
)

export const ProductInfoSharing: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false)
  const t = useTranslations('title')
  return (
    <>
      <button
        className='flex items-center gap-1 font-criteria text-sm leading-5 text-primary-500'
        onClick={() => setIsOpen(true)}
      >
        <Image
          alt='icon share'
          src='/icons/icon-share.svg'
          width={16}
          height={18}
        />
        {t('share')}
      </button>
      {isOpen && (
        <ModalDescriptionReferFriend
          isOpen
          onClose={() => setIsOpen(false)}
          isProductPage={true}
        />
      )}
    </>
  )
}
